import React from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { useRecoilState } from 'recoil';
import { SelectChangeEvent } from '@mui/material';
import { carTypeState } from 'features/optimization/state/cfdConfigAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const CarTypeSelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [cfdCarType, setCfdCarType] = useRecoilState(carTypeState);

  const handleCfdCarTypeChange = (event: SelectChangeEvent<string>) => {
    setCfdCarType(event.target.value as string);
  };

  return (
    <Box component="div">
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <FormControl
            size="small"
            sx={{
              minWidth: 100,
              backgroundColor: '#1e1e1e',
              borderRadius: 1,
            }}
          >
            <InputLabel
              id="morphing-origin-select-label"
              sx={{ color: '#f0f0f0' }}
            >
              type
            </InputLabel>
            <Select
              labelId="morphing-origin-select-label"
              id="morphing-origin-select"
              value={cfdCarType}
              onChange={handleCfdCarTypeChange}
              label="Select Type"
              size="small"
              sx={{
                color: '#f0f0f0',  // Set input text color
                fontSize: '12px',
                '.MuiSvgIcon-root': { color: '#f0f0f0' },  // Optional: Set dropdown arrow color
              }}
            >
              <MenuItem value="wing">Wing</MenuItem>
              <MenuItem value="car_rotating_tire_exposed">Car Rotating Tire Exposed</MenuItem>
              <MenuItem value="car_rotating_tire">Car Rotating Tire</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};
